import { ActionTypes } from "../contants/action-type.js";
import { getBusinessCategories} from '../../services/RegistrationService.js';


export function getBusinessCategoriesAction(role) {
    return (dispatch, getState) => {
        getBusinessCategories(role).then((response) => {
            dispatch(listBusinessCategories(response.data));
        });
    };
}


export const listBusinessCategories = (business_categories) => {
    return {
        type: ActionTypes.LIST_BUSINESS_CATEGORY,
        payload: business_categories
    }
}

